import { Membership } from '@/types/organization';

type UserAccessFields =
  | {
      membership?: Pick<Membership, 'role'> | null;
    }
  | null
  | undefined;

/** Profissional de equipe nunca vê aviso de plano: quem assina é o dono da organização. */
export function isBillingExempt(user: UserAccessFields): boolean {
  return user?.membership?.role === 'PROFESSIONAL';
}
